/* Copyright (c) 2018-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { NetworkHttpEndpointRetryConfig } from '../nv-http-endpoint/nv-http-endpoint';

export const NvHttpEndpointDefaultRetryConfig: NetworkHttpEndpointRetryConfig = {
    defaultTimeBetweenRetries: 0,
    defaultRetries: 0,
    retryOnTimeout: false,
    exponentialBackoffMaxDelay: 30000,
    exponentialBackoffFirstRetryInterval: 1000,
    exponentGrowthFactor: 1
};

export const TimeoutErrorName = 'TimeoutError';
export enum StatusCodeZeroErrorTypes {
    UnknownError = 0,
    RequestTimeout = -100,
    RequestCancelled = -101,
    NetworkStatusOffline = -102,
    DNSLookupFailed = -103
}

export const DefaultHTTPFailureDNSLookupCacheValidity = 60 * 60 * 1000;
